import React, { useState } from "react";
import styled from "styled-components";
import DataTable from "../components/DataTable";
import Components from "../components";
import apiClient from "../utils/apiClient";
import { Helmet } from "react-helmet-async";
import PageTitle from "../components/PageTitle";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const { ManagerAutocomplete } = Components;

const Content = styled.div`
  width: auto;
  flex: 1;
  padding: 40px 32px;
  margin-inline-start: 30px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  margin-top: 20px;
  color: #333;
`;

const HeadTabMenu = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
`;

const S2S = () => {
  const { t } = useTranslation();

  const [selectedClients, setSelectedClients] = useState([]);
  const [managerValue, setManagerValue] = useState("");
  const [selectedManager, setSelectedManager] = useState(null);
  const [refreshTable, setRefreshTable] = useState(0);

  const handleSelectionChange = (selectedRows) => {
    setSelectedClients(selectedRows);
  };

  const handleManagerSelect = (manager) => {
    setSelectedManager(manager);
    setManagerValue(manager.label);
  };

  const handleSubmit = async () => {
    if (selectedClients.length === 0 || !selectedManager) {
      alert(t("s2sCreate.validation.selectClientsAndManager"));
      return;
    }

    try {
      await apiClient.post("/s2s/assignments", {
        to_manager_id: selectedManager.value,
        clients: selectedClients,
      });
      alert(t("s2sCreate.assignmentSent"));
    } catch (error) {
      console.error("Ошибка отправки поручения", error);
    }
  };

  const handleRefresh = () => {
    setRefreshTable((prev) => prev + 1);
  };

  return (
    <Content>
      <Helmet>
        <title>{t("s2sCreate.metaTitle")}</title>
        <meta name="description" content={t("s2sCreate.metaDescription")} />
      </Helmet>

      <PageTitle>{t("s2sCreate.title")}</PageTitle>

      <SectionTitle>{t("s2sCreate.selectClientsTitle")}</SectionTitle>

      <HeadTabMenu>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleRefresh}
          fullWidth
        >
          {t("s2sCreate.refresh")}
        </Button>
      </HeadTabMenu>

      <DataTable
        checkboxSelection={true}
        isShowSearch
        columns={[
          {
            field: "fullName",
            headerName: t("s2sCreate.columns.clientFio"),
            flex: 1,
          },
          {
            field: "contractNumber",
            headerName: t("s2sCreate.columns.contractNumber"),
            flex: 1,
          },
        ]}
        path={"/clients"}
        onSelectionChange={handleSelectionChange}
        refresh={refreshTable}
      />

      <SectionTitle>{t("s2sCreate.selectManagerTitle")}</SectionTitle>

      <ManagerAutocomplete
        value={managerValue}
        onChange={setManagerValue}
        onSelect={handleManagerSelect}
      />

      <SectionTitle>{t("s2sCreate.confirmTitle")}</SectionTitle>

      <Button variant="contained" color="primary" onClick={handleSubmit}>
        {t("s2sCreate.submit")}
      </Button>
    </Content>
  );
};

export default S2S;
